/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetSimpleSeasonsByYearRangeParams,
  SimpleSeason
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetQuickSelectSeasonsUrl = () => {




  return `/api/Season/GetQuickSelectSeasons`
}

export const getQuickSelectSeasons = async ( options?: Parameters<typeof customInstance>[1]): Promise<SimpleSeason[]> => {

  return customInstance<SimpleSeason[]>(getGetQuickSelectSeasonsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQuickSelectSeasonsQueryKey = () => {
    return [
    `/api/Season/GetQuickSelectSeasons`
    ] as const;
    }


export const getGetQuickSelectSeasonsQueryOptions = <TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuickSelectSeasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuickSelectSeasons>>> = ({ signal }) => getQuickSelectSeasons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuickSelectSeasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuickSelectSeasons>>>
export type GetQuickSelectSeasonsQueryError = ErrorType<unknown>


export function useGetQuickSelectSeasons<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuickSelectSeasons>>,
          TError,
          Awaited<ReturnType<typeof getQuickSelectSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuickSelectSeasons<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuickSelectSeasons>>,
          TError,
          Awaited<ReturnType<typeof getQuickSelectSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuickSelectSeasons<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuickSelectSeasons<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuickSelectSeasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetQuickSelectSeasonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuickSelectSeasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuickSelectSeasons>>> = ({ signal }) => getQuickSelectSeasons({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetQuickSelectSeasonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuickSelectSeasons>>>
export type GetQuickSelectSeasonsSuspenseQueryError = ErrorType<unknown>


export function useGetQuickSelectSeasonsSuspense<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuickSelectSeasonsSuspense<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuickSelectSeasonsSuspense<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuickSelectSeasonsSuspense<TData = Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuickSelectSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuickSelectSeasonsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCurrentSeasonUrl = () => {




  return `/api/Season/GetCurrentSeason`
}

export const getCurrentSeason = async ( options?: Parameters<typeof customInstance>[1]): Promise<SimpleSeason> => {

  return customInstance<SimpleSeason>(getGetCurrentSeasonUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentSeasonQueryKey = () => {
    return [
    `/api/Season/GetCurrentSeason`
    ] as const;
    }


export const getGetCurrentSeasonQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentSeasonQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentSeason>>> = ({ signal }) => getCurrentSeason({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentSeasonQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentSeason>>>
export type GetCurrentSeasonQueryError = ErrorType<unknown>


export function useGetCurrentSeason<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentSeason>>,
          TError,
          Awaited<ReturnType<typeof getCurrentSeason>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentSeason<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentSeason>>,
          TError,
          Awaited<ReturnType<typeof getCurrentSeason>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentSeason<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCurrentSeason<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentSeasonQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCurrentSeasonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentSeasonQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentSeason>>> = ({ signal }) => getCurrentSeason({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCurrentSeasonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentSeason>>>
export type GetCurrentSeasonSuspenseQueryError = ErrorType<unknown>


export function useGetCurrentSeasonSuspense<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentSeasonSuspense<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentSeasonSuspense<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCurrentSeasonSuspense<TData = Awaited<ReturnType<typeof getCurrentSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentSeasonSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleSeasonsByYearRangeUrl = (params?: GetSimpleSeasonsByYearRangeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Season/GetSimpleSeasonsByYearRange?${stringifiedParams}` : `/api/Season/GetSimpleSeasonsByYearRange`
}

export const getSimpleSeasonsByYearRange = async (params?: GetSimpleSeasonsByYearRangeParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleSeason[]> => {

  return customInstance<SimpleSeason[]>(getGetSimpleSeasonsByYearRangeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleSeasonsByYearRangeQueryKey = (params?: GetSimpleSeasonsByYearRangeParams,) => {
    return [
    `/api/Season/GetSimpleSeasonsByYearRange`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimpleSeasonsByYearRangeQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleSeasonsByYearRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>> = ({ signal }) => getSimpleSeasonsByYearRange(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleSeasonsByYearRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>>
export type GetSimpleSeasonsByYearRangeQueryError = ErrorType<unknown>


export function useGetSimpleSeasonsByYearRange<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleSeasonsByYearRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>,
          TError,
          Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleSeasonsByYearRange<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>,
          TError,
          Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleSeasonsByYearRange<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleSeasonsByYearRange<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleSeasonsByYearRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleSeasonsByYearRangeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleSeasonsByYearRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>> = ({ signal }) => getSimpleSeasonsByYearRange(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleSeasonsByYearRangeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>>
export type GetSimpleSeasonsByYearRangeSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleSeasonsByYearRangeSuspense<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleSeasonsByYearRangeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleSeasonsByYearRangeSuspense<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleSeasonsByYearRangeSuspense<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleSeasonsByYearRangeSuspense<TData = Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError = ErrorType<unknown>>(
 params?: GetSimpleSeasonsByYearRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleSeasonsByYearRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleSeasonsByYearRangeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






